import { getWhatsAppLink, trackWhatsAppClick } from "@/lib/analytics";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp({ whatsappNumber }) {
  return (
    <>
      {/* Desktop/mobile floating button */}
      <a
        href={getWhatsAppLink(whatsappNumber)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick("floating_button")}
        className="fixed bottom-20 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_8px_24px_rgba(37,211,102,0.4)] transition-transform hover:scale-110 sm:bottom-6"
        aria-label="WhatsApp'tan yazın"
        data-testid="floating-whatsapp-button"
      >
        <MessageCircle className="h-7 w-7 text-white" fill="white" />
      </a>

      {/* Mobile sticky bottom bar */}
      <div className="fixed bottom-0 left-0 z-40 w-full border-t border-white/10 bg-black/90 backdrop-blur-xl sm:hidden">
        <a
          href={getWhatsAppLink(whatsappNumber)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("mobile_sticky_bar")}
          className="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold text-black bg-gold"
          data-testid="mobile-sticky-whatsapp-bar"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp'tan Yaz
        </a>
      </div>
    </>
  );
}
